import md5 from 'js-md5'

const global = {
  height: window.innerHeight,
  width: window.innerWidth,
  navbarHeight: 50
  // baseURL: 'http://127.0.0.1:8081'
}

/**
 * 获取uuid
 */
global.getUUID = function name () {
  let s = [];
  let hexDigits = "0123456789abcdef";
  for (let i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = "-";

  let uuid = s.join("");
  return uuid;
}

global.escapeDecode = function (str) {
  str = str.replace(new RegExp("&lt;", "g"), "<");
  str = str.replace(new RegExp("&gt;", "g"), ">");
  str = str.replace(new RegExp("&quot;", "g"), "\"");
  str = str.replace(new RegExp("&amp;", "g"), "&");
  return str;
}

/**
 * 将字符串转换为ArrayBuffer，注意，此函数为异步方法，需要通过回调来获取返回值
 * 
 * @param s 字符串
 * @param f 转换完成以后的回调函数，1个入参即为返回的ArrayBuffer对象
 */
global.str2ab = function (s, f) {
  let b = new Blob([s], { type: 'text/plain' });
  let r = new FileReader();
  r.readAsArrayBuffer(b);
  r.onload = function () { if (f) f.call(null, r.result) }
}

/**
 * 将ArrayBuffer转换为字符串，注意，此函数为异步方法，需要通过回调来获取返回值
 * 
 * @param s ArrayBuffer对象，即二进制数据
 * @param f 转换完成以后的回调函数，1个入参即为返回的string对象
 */
global.ab2str = function (u, f) {
  let b = new Blob([u]);
  let r = new FileReader();
  r.readAsText(b, 'utf-8');
  r.onload = function () { if (f) f.call(null, r.result) }
}

global.ab2Base64 = function (ab) {
  if (!(ab instanceof Uint8Array)) {
    ab = new Uint8Array(ab);
  }
  let ret = "";
  for (let i = 0; i < ab.byteLength; i++) {
    ret += String.fromCharCode(ab[i]);
  }
  return btoa(ret);
}

/**
 * 将base64字符串转换为二进制数组
 * 
 * @param b64 base64字符串
 * @returns UintArray对象
 */
global.base642ab = function (b64) {
  let temp = atob(b64);
  let ret = new Uint8Array(temp.length);
  for (let i = 0; i < temp.length; i++) {
    ret[i] = temp.charCodeAt(i);
  }
  return ret;
}

global.simpleConfuse = function (ab, localKey) {
  if (ab instanceof Uint8Array) {
    console.log();
  } else {
    ab = new Uint8Array(ab);
  }
  let key = atob(localKey);
  let abKey = new Uint8Array(key.length);
  for (let i = 0; i < key.length; i++) {
    abKey[i] = key.charCodeAt(i);
  }

  let tmpAb = new Uint8Array(ab.byteLength);
  for (let k = 0; k < ab.byteLength; k++) {
    tmpAb[k] = ab[k];
  }

  let j = 0;
  for (let f = 0; f < tmpAb.byteLength; f++) {
    if (j > abKey.byteLength - 1) {
      j = 0;
    }
    tmpAb[f] = tmpAb[f] ^ abKey[j];
    j++;
  }
  return tmpAb;
}

global.md5 = function (str) {
  let ret = null;
  ret = md5(str);
  return ret;
}

global.isLogin = function () {
  let loginToken = sessionStorage.getItem("token");
  if (loginToken) {
    return true;
  } else {
    return false;
  }
}
global.clearAllCookie = function () {
  let keys = document.cookie.match(/[^ =;]+(?=\=)/g);
  if (keys) {
    for (let i = keys.length; i--;)
      document.cookie = keys[i] + '=0;path=/;expires=' + new Date(0).toUTCString();//清除当前域名下的,例如：m.kevis.com
    // document.cookie = keys[i] + '=0;path=/;domain=' + document.domain + ';expires=' + new Date(0).toUTCString();//清除当前域名下的，例如 .m.kevis.com
    // document.cookie = keys[i] + '=0;path=/;domain=kevis.com;expires=' + new Date(0).toUTCString();//清除一级域名下的或指定的，例如 .kevis.com
  }
}
global.setCookie = function (cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + "; " + expires;
}
global.isPC = function () {
  let userAgentInfo = navigator.userAgent;
  let Agents = ["Android", "iPhone",
    "SymbianOS", "Windows Phone",
    "iPad", "iPod"];
  let flag = true;
  for (let v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
}
global.isPhone = function () {
  let userAgentInfo = navigator.userAgent;
  let Agents = ["Android", "iPhone",
    "SymbianOS", "Windows Phone"];
  let flag = false;
  for (let v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = true;
      break;
    }
  }
  return flag;
}
//防抖函数
global.dobounce = function (func, delay, immediate) {
  let timer = null;
  return function () {
    let context = this;
    let args = arguments;
    if (timer) clearTimeout(timer);
    if (immediate) {
      //根据距离上次触发操作的时间是否到达delay来决定是否要现在执行函数
      let doNow = !timer;
      //每一次都重新设置timer，就是要保证每一次执行的至少delay秒后才可以执行
      timer = setTimeout(function () {
        timer = null;
      }, delay);
      //立即执行
      if (doNow) {
        func.apply(context, args);
      }
    } else {
      timer = setTimeout(function () {
        func.apply(context, args);
      }, delay);
    }
  }
}
global.loadNative = function () {
  //原生调用js
  window.appHideHeader = function () {
    // window.alert("调用成功");
    var header = window.document.querySelector(".app_header");
    if (header) {
      header.style.display = "none";
    }
    var footer = window.document.querySelector(".home_footer");
    if (footer) {
      footer.style.display = "none";
    }
  }
}

export default global